import { Fragment } from "react";
import { t } from "@songtradr-one/shared-common";
import { Props } from "./T.Parts";

/**
 * Template string component with line-break support.
 * Interpolates `{key}` placeholders via `t()` and renders
 * `\n` newlines as `<br />` elements.
 *
 * Unopinionated about typography — pass a render-prop child to wrap the
 * content in a caller-owned element.
 *
 * @example
 * <T template="Hello {name}" vars={{ name: "Alice" }} />
 * // renders: Hello Alice
 *
 * @example
 * <T template="Line one\nLine two" />
 * // renders: Line one<br />Line two
 *
 * @example
 * <T template="Hello">{(c) => <Body variant="small">{c}</Body>}</T>
 * // renders: <Body variant="small">Hello</Body>
 */
export const T = ({ template, vars, children }: Props) => {
  const result = t(template, vars);
  const lines = result.split("\n");

  const content = lines.map((line, i) => (
    <Fragment key={i}>
      {i > 0 && <br />}
      {line}
    </Fragment>
  ));

  return children ? children(content) : content;
};
